import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { SearchActivityEvents } from 'generated/graphql';

import {
  activityEventExpantionStateSelector, ActivityEventItemExpansionState,
  setActivityItemExpansionState
} from '../../../_state/activity-event-expansion.state';

@Component({
  selector: 'app-note-event',
  templateUrl: './note-event.component.html'
})

export class ASNoteEventComponent extends WithDisposableSubject() implements OnInit {

  @Input() item: SearchActivityEvents.Node;

  showFullText = false;
  /**
   *
   */
  constructor(
    private store: Store<ActivityEventItemExpansionState>
  ) {
    super();
  }

  ngOnInit() {
    this.store.select(
      activityEventExpantionStateSelector({ itemId: this.item.id })
    ).pipe(
      takeUntil(this.disposer)
    ).subscribe(
      (showFullText) => {
        this.showFullText = showFullText;
      });
  }

  setShowFullText(value: boolean) {
    this.store.dispatch(
      setActivityItemExpansionState({
        itemId: this.item.id,
        expanded: value
      })
    );
  }

}
